import PolicyAmendmentDetail from './PolicyAmendmentDetail'

export default PolicyAmendmentDetail
